// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a53c78da","513":"0494edbd","703":"09972037","787":"619cef40"}[chunkId] + ".chunk.js";
};